export const APP_FETCH = 'app/APP_FETCH';
export const APP_FETCHED = 'app/APP_FETCHED';
export const NAVIGATION_FETCH = 'app/NAVIGATION_FETCH';
export const NAVIGATION_FETCHED = 'app/NAVIGATION_FETCHED';
export const FETCHED_ROUTE_BY_URL = 'app/FETCHED_ROUTE_BY_URL';
export const FETCH_ROUTE_BY_URL = 'app/FETCH_ROUTE_BY_URL';
export const APP_SET_CURRENT_ID = 'app/APP_SET_CURRENT_ID';
export const SET_PREVIOUS_PAGE = 'app/SET_PREVIOUS_PAGE';
